/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export const getProviderName = (val: Response.Stack.StackItemProvider) => {
  switch (val) {
    case 'aws':
      return 'AWS'
    case 'azure':
      return 'Azure'
    case 'gcp':
    default:
      return 'GCP'
  }
}
